var productsToAdd = [];

class UpsellSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeFormHandling();
    this.quantityUpdate();
  }

  initializeFormHandling() {
    const updateProductsToAdd = () => {
      productsToAdd = [];
      document.querySelectorAll('.MA-product-addon__item').forEach(container => {
        const variantId = container.querySelector('.MA-variant-id')?.value;
        const quantityInput = container.querySelector('.MA-quantity__input');
        const quantity = quantityInput ? parseInt(quantityInput.value) : 0;
        console.log(quantity);
        const checkbox = container.querySelector('.MA-checkbox');

        if (checkbox.checked) {
          if (variantId && !isNaN(quantity) && quantity > 0) {
            productsToAdd.push({ id: variantId, quantity });
          }
        }
      });
    };

    this.querySelectorAll('.MA-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', updateProductsToAdd);
    });

    document.querySelectorAll('.Ma-btn.product-form__submit, .sticky-atc-link .Ma-class').forEach(btn => { 
      btn.addEventListener('click', () => {
        updateProductsToAdd();
        // if (productsToAdd.length) {
        //   this.addProductsToCart(productsToAdd);
        // } else {
        //   console.warn('No products selected to add to cart.');
        // }
        // this.deselectAll();
      });
    });
  }

  async addProductsToCart(products) {
    console.log(products);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: products }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Products successfully added to cart:', data);
      } else {
        console.error('Failed to add products:', response.statusText);
      }
    } catch (error) {
      console.error('Error while adding products to cart:', error);
    }
  }

  deselectAll(){
    this.querySelectorAll('input').forEach(input => {input.checked = false});
  }

  quantityUpdate(){
    document.querySelectorAll('.MA-quantity-selector').forEach(selector => {
      const input = selector.querySelector('.MA-quantity__input');
      const [decreaseButton, increaseButton] = selector.querySelectorAll('.MA-quantity-selector__button');
      
      const min = +input.min || 1;
      const max = +input.max || Infinity;
      const step = +input.step || 1;
      
      decreaseButton.onclick = () => input.value = Math.max(min, +input.value - step);
      increaseButton.onclick = () => input.value = Math.min(max, +input.value + step);
      
      input.oninput = () => input.value = Math.max(min, Math.min(max, +input.value || min));
    });
  }
}

customElements.define('ma-upsell-selector', UpsellSelector);
